import { Typography } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import RoomtypeIcon from '@material-ui/icons/MeetingRoom'
import React from 'react'

import { getTranslate } from '../../localization'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface InventoryRoomtypeRowProps {
  name: string
  weekendIndexes: number[]
  numberOfProviders: number
  showProviders: boolean
  setshowProviders: React.Dispatch<React.SetStateAction<boolean>>
  range: 'TWO_WEEKS' | 'MONTH'
}

const InventoryRoomtypeRow: React.FC<InventoryRoomtypeRowProps> = ({
  name,
  weekendIndexes,
  range,
  numberOfProviders,
  setshowProviders,
  showProviders
}) => {
  const classes = useStyles()

  return (
    <div>
      <div
        className={[
          classes.roomTypeRow,
          range === 'MONTH' ? classes.roomTypeRowForMonth : ''
        ].join(' ')}>
        <div className={classes.rowNameContainer}>
          <div className={classes.roomIcon}>
            <RoomtypeIcon />
          </div>
          <Typography variant="h4" className={classes.rowName}>
            {getTranslate(name)}
          </Typography>
          <Typography
            variant="h6"
            className={classes.numberOfRatePlans}
            component="span"
            onClick={() => setshowProviders(!showProviders)}>
            {numberOfProviders} {getTranslate('PROVIDER')}
          </Typography>
          <div className={classes.ratePlansLoading}>
            <ArrowRightIcon
              onClick={() => setshowProviders(!showProviders)}
              className={[
                classes.channelArrowRight,
                showProviders ? classes.channelArrowRightCollapsed : ''
              ].join(' ')}
            />
          </div>
        </div>
        <div className={classes.dayContainer} />
        {Array(range == 'TWO_WEEKS' ? 14 : 31)
          .fill('')
          ?.map((availItem, index) => {
            return (
              <div
                key={`${name}-${index.toString()}`}
                className={[
                  classes.dayContainer,
                  weekendIndexes.includes(index % 7)
                    ? classes.weekendDayContainer
                    : ''
                ].join(' ')}>
                <input value={availItem} disabled />
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default InventoryRoomtypeRow
